import { useTranslation } from "react-i18next";
import { Control, FieldPath, FieldValues } from "react-hook-form";
import { SingleFormSelector } from "../../common/input/Selector/SingleFormSelector";
import { NoContractTypesHint } from "./NoContractTypesHint";

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  options: { label: string; value: string }[];
}

export const ContractTypeFormSelector = <T extends FieldValues>({ control, name, options }: Props<T>) => {
  const { t } = useTranslation();
  return (
    <SingleFormSelector
      options={options}
      name={name}
      label={t("Select type")}
      helperText={options.length === 0 ? <NoContractTypesHint opensInNewTab /> : t("Select a type")}
      control={control}
      placeholderText=""
      noOptionsProvidedMessage={t("No contract types yet.")}
      noMatchingOptionsMessage={t("No matching types")}
      errorMessage={undefined}
      isDisabled={options.length === 0}
    />
  );
};
